import moment from 'moment';
import '../../CSS/Table.css';
import { Row, Col, Tag } from 'antd';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { config } from '../../constant';
import ReactEcharts from '../../Echarts/Echarts';
import { stackedBarMock } from '../../../Mock/MockJson';
import StyledTable from "../../../../../commons/styles/table";
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const StackedLine = (props) => {

  const [option, setOption] = useState({});
  const [, setData] = useState([]);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);

  const requestCheck = useRef(true);
  let timeTicket = useRef(null);
  let abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);
  useEffect(() => {
    return () => {
        abortController.current.abort();
      clearInterval(timeTicket);
    };
  });

  const getOption = () => {
    let theme = props.selectedThemeing;
    let option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow' // 'line' | 'shadow'
        }
      },
      legend: {
        left: 'center',
        itemHeight: 25,
        itemWidth: 25,
        itemGap: 10.5,
        textStyle: {
          color: theme === 'lightTheme' ? 'black' : 'white',
          fontWeight: 'bold',
          fontSize: 18
        }
      },
      // yAxis: {
      //   type: "value",
      // },
      xAxis: {
        type: 'category',
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },

        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        },
        scale: true
      },

      yAxis: {
        scale: true,
        type: 'value',
        // splitLine: {
        //     lineStyle: {
        //         type: 'dashed'
        //     }
        // },
        splitLine: {
          show: false
        },
        // scale: true,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        }
      },
      dataZoom: {
        type: 'slider'
      },

      series: [],
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: theme === 'lightTheme' ? 'black' : 'black',
            title: 'download',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      }
    };
    return option;
  };
  const getData = async () => {
    requestCheck.current = false;
    // let theme = this.props.selectedThemeing;
    let json = [];
    let series = [];
    const { graphprops } = props;

    let option = getOption();
    // let legends = [];

    setErrorInAPI(false);
    setNoDataInDB(false);

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = stackedBarMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      setData(json);
      let columns = [];
      if (
        json &&
        json.table &&
        Array.isArray(json.table) &&
        props.graphprops &&
        props.graphprops.table &&
        props.graphprops.table === 'yes'
      ) {
        let dataSource = json.table;
        columns =
          dataSource &&
          dataSource[0] &&
          Object.keys(dataSource[0]).map((tableKey) => {
            return {
              title: tableKey,
              dataIndex: tableKey,
              key: tableKey
            };
          });
        setColumns[columns];
        setDataSource(dataSource);
      }
      let xAxisDataArray = [];
      let namesArray = [];
      xAxisDataArray =
        json && json.bar && json.bar[0]
          ? json.bar[0].intervalAlias.map((intervalAlias) => {
            let date = graphprops && graphprops.type === 'live' ? intervalAlias : intervalAlias;
            return date;
          })
          : [];

      let dataObj = {};

      json &&
        json.bar &&
        Array.isArray(json.bar) &&
        json.bar.map((data) => {
          namesArray.push(data.tagName);
          dataObj = {
            name: data.tagName,
            type:
              data.tagName && graphprops.tags && graphprops.tags.includes(data.tagName)
                ? 'line'
                : 'line',
            stack: graphprops.tags && graphprops.tags.length === 0 ? 'true' : null,
            data: data.tagValue,
            yAxisIndex:
              data.tagName &&
                graphprops.tags &&
                graphprops.tags.includes(data.tagName) &&
                data.tagName !== 'MIN'
                ? 1
                : 0,
            markPoint: {
              data: props.graphprops.minMax
                ? [
                  { type: 'max', name: 'Max' },
                  { type: 'min', name: 'Min' }
                ]
                : null
            }
          };
          series.push(dataObj);
          return {};
        });
      let yAxis = [];
      series &&
        Array.isArray(series) &&
        series.map((seriesData) => {
          if (seriesData && seriesData.name && seriesData.name !== undefined) {
            yAxis.push({
              type: 'value'
              // name: seriesData.name
            });
            option.yAxis = yAxis;
          }
          return {};
        });

      let finalArray = xAxisDataArray;
      option.xAxis.data = finalArray;

      option.series = series;
      setOption(option);
      setRefreshDateTime(moment());
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : props.graphprops &&
        props.graphprops.table &&
        props.graphprops.table !== 'yes' ? (
        <ReactEcharts
          option={option}
          style={{ height: '80%', width: '100%' }}
          className="react_for_echarts"
        />
      ) : (
        <div style={{ padding: '10px' }}>
          <Row>
            <Col span={24}>
              <ReactEcharts
                option={option}
                style={{ height: '30vh' }}
                className="react_for_echarts"
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div style={{ padding: '20px' }}>
                {props.graphprops &&
                  props.graphprops.table &&
                  props.graphprops.table === 'yes' &&
                  dataSource.length > 0 ? (
                  <StyledTable size="small"
                    dataSource={dataSource && dataSource}
                    columns={columns && columns ? columns : []}
                    pagination={false}

                    style={{ padding: '0px 10px', marginTop: '12px' }}
                    scroll={{ y: 240 }}
                    bordered
                  />
                ) : null}
              </div>
            </Col>
          </Row>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(StackedLine);
